export default "__VITE_ASSET__CQLbX$8Q__"